module.exports = __webpack_public_path__ + "media/images/icon-publications-4cd6a96b0995cbbeb072da769b3d4f30.svg";